import { AxiosResponse } from 'axios';
import axiosInstance from '../../../../../services/axios/axios';
import { then, catchAxiosError } from '../../../../../services/axios/_utility';

/**
 * Asynchronously retrieves end-user's notifications.
 * @param {Number} id end-user unique identifier.
 * @param {Date} [dateStart=] starting scope of consideration.
 * @param {Date} [dateEnd=] ending scope of consideration.
 * @param {Boolean} [isSelfRequest=] exclusively include or exclude requests for self.
 * @param {Number} [range=] number of requests to retrieve.
 * @param {Function} [dispatch=] forwarded Redux store's method for dispatching actions.
 * @returns {Promise<AxiosResponse<object[]>>} array of request objects.
 */
export const getMyRequests = async (
	id,
	dateStart = null,
	dateEnd = null,
	isSelfRequest = null,
	range = null,
	dispatch = null
) => {
	try {
		return await axiosInstance
			.get('api/WorkQueue/GetMyRequests', { 
				params: {
					id: id,
					dateStart: dateStart,
					dateEnd: dateEnd,
					isSelfRequest: isSelfRequest,
					range: range,
				},
			})
			.then(response => then(response, payload => payload, dispatch));
	} catch (e) {
		throw catchAxiosError(e);
	}
};
